export const defaultFilter = (item) =>
  (item.accountTypeId === "Bank" || item.accountTypeId === "Crypto") &&
  item.accountStateId === "Open";
